import React, { Component } from 'react';
import { useState } from 'react';
import MapImage from './images/Map.png';
import icon from './images/icons8-place-marker-48.png';
import iconhover from './images/icons8-place-marker.gif';
import { Container } from 'reactstrap';
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import './Home.css';
import click from './shortclick.mp3';  

// Define a handler that redirects to the marker's URL when clicked


const PinIcon = ({ x, y, src, hoverSrc, url, description }) => {
    // Use a state variable to keep track of whether the mouse is over the icon or not.
    const [isHovered, setIsHovered] = useState(false);
    const [show, setShow] = useState(false);

    // Define a function that handles the mouse enter event and sets the state to true.
    const handleMouseEnter = () => {
        setIsHovered(true);
        setShow(!show);
    };

    // Define a function that handles the mouse leave event and sets the state to false.
    const handleMouseLeave = () => {
        setIsHovered(false);
        setShow(!show);
    };

    const handleClick = (url) => {
        // navigate to another web page based on the location name
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => {
            window.location.href = url;
        }
    }

    // Return a JSX element that renders an image tag with the appropriate attributes and styles.
    return (
        <OverlayTrigger
            key={description}
            placement="top"
            show={show}
            overlay={<Tooltip id={`tooltip-${description}`}>{description}</Tooltip>}
        >
        <img
            src={isHovered ? hoverSrc : src} // Use the hoverSrc if the mouse is over the icon, otherwise use the src.
            alt="pin icon" // Provide an alternative text for accessibility.
            style={{
                position: "absolute", // Use absolute positioning to place the icon on top of the background image.
                left: x + "px", // Use the x prop as the left offset in pixels.
                top: y + "px", // Use the y prop as the top offset in pixels.
                width: "40px", // Set a fixed width for the icon in pixels. You can change this as you like.
                height: "40px", // Set a fixed height for the icon in pixels. You can change this as you like.
                transition: "transform 0.3s ease-in-out", // Use a transition effect to animate the icon when it changes size on hover.
            }}
            onMouseEnter={handleMouseEnter} // Attach the mouse enter handler to the image tag.
            onMouseLeave={handleMouseLeave} // Attach the mouse leave handler to the image tag.
            onClick={() => handleClick(url)}
            />
        </OverlayTrigger>
    );
}

const ImageWithPins = ({ pins }) => {
    return (
        <div>
            {pins.map((pin) => (
                // For each pin object in the pins array, render a PinIcon component with its properties as props.
                <PinIcon
                    key={pin.x + "," + pin.y} // Use a unique key for each PinIcon component based on its coordinates.
                    x={pin.x - 20}  // Pass the x coordinate as a prop.
                    y={pin.y - 30} // Pass the y coordinate as a prop.
                    src={icon}
                    hoverSrc={iconhover}
                    url={pin.url}
                    description={pin.description}
                />
            ))}
        </div>
    );
}

// A custom component that displays an image
function FloorplanImage(props) {
    return (
        <div className="map-image" align-items="center">
            < img src={props.src} alt={props.alt} />
        </div>
    );
}


// Define the marker positions and the corresponding urls to open on click
const pins = [
    { x: 803, y: 415, src: { icon }, hoverSrc: { iconhover }, url: '/map', description: "欣田邨" },
    { x: 859, y: 353, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "鴻福邨" },
    //{ x: 767, y: 440, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "田景邨" },
    //{ x: 757, y: 442, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "良景邨" },
    //{ x: 792, y: 504, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "友愛邨" },
    //{ x: 863, y: 284, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "天瑞邨" },
    //{ x: 890, y: 298, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "天慈邨" },
    //{ x: 880, y: 307, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "天耀邨" },
    //{ x: 942, y: 306, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "朗屏邨" },
    { x: 1000, y: 332, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "朗善邨" },
    //{ x: 1238, y: 165, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "清河邨" },
    //{ x: 1255, y: 143, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "天平邨" },
    //{ x: 1285, y: 171, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "祥華邨" },
    //{ x: 1277, y: 204, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "華明邨" },
    //{ x: 1346, y: 305, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "太和邨" },
    //{ x: 1379, y: 311, src: { icon }, hoverSrc: { iconhover }, url: '/', description: "廣福邨" },
];

class Home extends Component {
    // Handle the marker click event
    handleMarkerClick = (url) => {
        // Open the url in the same window
        window.location.href = url;
    };

    render() {
        return (

            <div className="midcolumn" >
                <FloorplanImage src={MapImage} />
                <ImageWithPins pins={pins} />
                </div >

        );
    }
}

export default Home;